module.exports = __webpack_public_path__ + "static/media/profile.4c80ca50.png";